// extracted by mini-css-extract-plugin
export default {"container":"style_container__mwGvI","header":"style_header__tCeZR","logoIcon":"style_logoIcon__dtpnD","whatsapp":"style_whatsapp__IT7UJ","centerBlock":"style_centerBlock__qTUmJ"};